import asset from 'json/assets'
import Wrapper from 'layout/Wrapper/Wrapper'
import React from 'react'
import styles from 'styles/component/ProfileSetting.module.scss'
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { Button } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';

const tableItem = [
    {
        username:"Account User Name",
        designation:"Administrator",
    },
    {
        username:"Account User Name",
        designation:"Administrator",
    },
    {
        username:"Bob Smith",
        designation:"Administrator",
        selected:true
    },
    {
        username:"Account User Name",
        designation:"Administrator",
    },
    {
        username:"Account User Name",
        designation:"Administrator",
    },
    {
        username:"Account User Name",
        designation:"Administrator",
    },
    {
        username:"Account User Name",
        designation:"Administrator",
    }
]



const ProfileSetting = () => {
    return (
        <div className="main_wraper">
            <Wrapper isHeader={false} >
                <div className={styles.range_sec}>
                    <div className={styles.range_head}>
                        <p>User</p>
                        <div className={styles.ButtonGroup}>
                            <Button><AddIcon /></Button>
                            <Button><SearchIcon /></Button>
                        </div>
                    </div>
                    <div className={styles.range_table}>
                        <table className={styles.table_bar}>
                            {/* <thead>
                                    <tr>
                                    
                                    </tr>
                                </thead> */}
                            <tbody>
                                {tableItem.map((item,index) => {
                                    return (
                                        <tr key={index}>
                                            <td className={styles.name_cont}>{item.username}</td>
                                            <td className={styles.city_cont}>{item.designation}</td>
                                            <td>
                                                <div className={styles.action_bar}>
                                                    <Button><CancelIcon/></Button>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                                )}

                            </tbody>
                        </table>
                    </div>
                </div>

                <div className={styles.tableDetails}>
                    <div className={styles.tableHead}>
                        <p>Bob Smith</p>
                        <div className={styles.ButtonGroup}>
                            <Button><EditIcon/></Button>
                            <Button><CancelIcon/></Button>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </div>
    )
}

export default ProfileSetting